/*
 * @description:
 */
import { useRef, useEffect } from 'react';
import { Input } from 'antd';
import styles from './index.less';

const ResetTextArea = (props: any) => {
  const textAreaRef = useRef<any>();
  useEffect(() => {
    // textArea样式
    if (props.textareastyle) {
      Object.keys(props.textareastyle).forEach((e) => {
        if (textAreaRef.current?.resizableTextArea?.textArea?.style) {
          textAreaRef.current.resizableTextArea.textArea.style[e] =
            props.textareastyle[e];
        }
      });
    }
  }, [props.textareastyle]);

  return (
    <div
      id={styles['textarea-wrapper']}
      style={{
        width: props.width || '640px',
      }}
    >
      <Input.TextArea {...props} ref={textAreaRef} />
    </div>
  );
};
export default ResetTextArea;
